export { default } from './useGeoSearch';
